module.exports = __webpack_public_path__ + "img/10.f254fac8.png";